import state from './moduleMRMRState'
import mutations from './moduleMRMRMutations'
import actions from './moduleMRMRActions'
import getters from './moduleMRMRGetters'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

